export default "__VITE_ASSET__825b3e52__"